<template>
  <el-dialog :visible="visible" @close="$emit('update:visible', false)" :before-close="beforeClose" class="dialog-w80">
    <el-form :model="form" :rules="rules" ref="orderForm" class="order-form">
      <h2 class="text-center mt-0">Добавить заказ</h2>
      <h3 class="mt-0 mb-3">Заказ</h3>
      <div class="row row_offset">
        <div class="col-4 pr-0">
          <el-form-item prop="number">
            <el-input v-model="form.number" />
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.number) }">Номер заказа</span>
          </el-form-item>
        </div>
        <div class="col-4 pr-0">
          <el-form-item prop="serviceId">
            <el-select class="w-100" v-model="form.serviceId" filterable placeholder="" ref="serviceIdRef">
              <el-option v-for="item in services" :key="item.id" :label="item.displayName" :value="item.id"></el-option>
            </el-select>

            <span class="floating-span"
                  :class="{'floating-span_active': $notEmpty(form.serviceId) || $notEmpty($refs.serviceIdRef && $refs.serviceIdRef.query)}">
              Тип заказа
            </span>
          </el-form-item>
        </div>
        <div class="col-4 pr-0">
          <el-form-item prop="workDate">
            <el-date-picker v-model="form.workDate" type="date" :clearable="false" value-format="yyyy-MM-dd" format="dd.MM.yyyy"
                            ref="workDateRef"
                            class="w-100" :pickerOptions="pickerOptions" />
            <span class="floating-span floating-span_prefix"
                  :class="{ 'floating-span_active': $notEmpty(form.workDate) || $notEmpty($refs.workDateRef && $refs.workDateRef.userInput) }">
              Дата оказания услуги
            </span>
          </el-form-item>
        </div>
<!--        <div class="col-3">-->
<!--          <el-form-item prop="workTime">-->
<!--            <el-select class="w-100" v-model="form.workTime" placeholder="">-->
<!--              <el-option v-for="option in workTimes" :key="option.value" :label="option.value" :value="option.value"></el-option>-->
<!--            </el-select>-->
<!--            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.workTime) }">Выберите время</span>-->
<!--          </el-form-item>-->
<!--        </div>-->
      </div>
      <h3 class="mt-5 mb-3">Клиент</h3>
      <div class="row row_offset">
        <div class="col-6 pr-0">
          <el-form-item prop="clientName">
            <el-input v-model="form.clientName" maxlength="100" />
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.clientName) }">ФИО</span>
          </el-form-item>
        </div>
        <div class="col-3 pr-0">
          <el-form-item prop="clientPhone">
            <el-input v-model="form.clientPhone" v-mask="MASKS.PHONE" />
            <input v-show="false" type="text" v-model="form.clientPhone" v-mask="MASKS.PHONE">
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.clientPhone) }">Телефон</span>
          </el-form-item>
        </div>
        <div class="col-3">
          <el-form-item prop="clientAdditionalPhone">
            <el-input v-model="form.clientAdditionalPhone" v-mask="MASKS.PHONE" />
            <input v-show="false" type="text" v-model="form.clientAdditionalPhone" v-mask="MASKS.PHONE">
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.clientAdditionalPhone) }">Доп. телефон</span>
          </el-form-item>
        </div>
      </div>
      <div class="row row_offset">
        <div class="col">
          <el-form-item prop="address">
            <el-input v-model="form.address" />
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.address) }">Город, улица, дом, строение, кв</span>
          </el-form-item>
        </div>
      </div>
      <div class="row row_offset">
        <div class="col">
          <el-form-item prop="comment">
            <el-input type="textarea" :rows="3" resize="none" v-model="form.comment" maxlength="200" show-word-limit />
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.comment) }">Комментарий к заказу</span>
          </el-form-item>
        </div>
      </div>
      <h3 class="mt-4 mb-3">Подрядчик</h3>
      <div class="row row_offset">
        <div class="col-6 col-xl-3 pr-0">
          <el-form-item prop="contractorId">
            <el-select class="w-100" ref="contractorIdRef"
                       v-model="form.contractorId" filterable placeholder="">
              <el-option v-for="(item, index) in contractors" :key="`key-${index}`" :label="item.name" :value="item.id" />
            </el-select>
            <span class="floating-span"
                  :class="{'floating-span_active': $notEmpty(form.contractorId) || $notEmpty($refs.contractorIdRef && $refs.contractorIdRef.query)}">
              Выберите подрядчика
            </span>
          </el-form-item>
        </div>
        <div class="col-6 col-xl-3">
          <el-form-item prop="shop">
            <el-input v-model="form.shop" />
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(form.shop) }">Магазин</span>
          </el-form-item>
        </div>
      </div>
      <h3 class="mt-5 mb-3">Строки заказа</h3>
      <div class="row" v-for="(item, index) in form.orderRows" :key="item.id">
        <div class="col-2 pr-0">
          <el-form-item :prop="`orderRows.${index}.orderNumber`" :rules="required">
            <el-input v-model="item.orderNumber" />
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(item.orderNumber) }">Номер заказа на продажу</span>
          </el-form-item>
        </div>
        <div class="col-2 pr-0">
          <el-form-item :prop="`orderRows.${index}.vendorCode`" :rules="required">
            <el-input v-model="item.vendorCode" />
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(item.vendorCode) }">Код товара</span>
          </el-form-item>
        </div>
        <div class="col pr-0">
          <el-form-item :prop="`orderRows.${index}.name`" :rules="required">
            <el-input v-model="item.name" />
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(item.name) }">Наименование</span>
          </el-form-item>
        </div>
        <div class="col pr-0">
          <el-form-item :prop="`orderRows.${index}.description`" :rules="required">
            <el-input v-model="item.description" />
            <span class="floating-span" :class="{ 'floating-span_active': $notEmpty(item.description) }">Описание</span>
          </el-form-item>
        </div>
        <div class="col pr-0">
          <el-form-item :prop="`orderRows.${index}.goodsPrice`" :rules="required">
            <el-input :value="item.goodsPrice"  @input="item.goodsPrice = replaceNumberFloatingPoint($event)" />
            <span class="floating-span" :class="{ 'floating-span_active': replaceNumberFloatingPoint(item.goodsPrice) }">Стоимость</span>
          </el-form-item>
        </div>
        <div class="col-auto">
          <el-form-item prop="orderRowsCount">
            <el-input-number v-model="item.count" controls-position="right" :min="1" class="input-number" />
            <i @click="removeItemOrderList(index)" class="el-icon-delete el-icon-hover icon-delete pointer ml-3" />
          </el-form-item>
        </div>
      </div>
      <el-button size="medium" class="mt-3 button-blue" icon="el-icon-plus" @click="addItemOrderList">Добавить</el-button>
      <div class="row mt-5">
        <div class="col-12 col-xl-3 mx-auto">
          <el-button class="w-100" type="primary" @click="submitForm" :loading="createProgress">Сохранить</el-button>
        </div>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { MESSAGES } from '@/commons/constants/errorMessages';
import workTimes from '@/commons/constants/workTimes';
import MASKS from '@/commons/constants/masks';

const {
  replaceNumberFloatingPoint,
} = require('@/commons/helpers');

export default {
  props: {
    visible: Boolean,
  },
  data: () => ({
    workTimes,
    form: {
      number: '',
      shop: '',
      clientName: '',
      clientPhone: '',
      clientAdditionalPhone: '',
      comment: '',
      address: '',
      workDate: '',
      workTime: '',
      serviceId: null,
      contractorId: null,
      orderRows: [
        {
          orderNumber: '',
          vendorCode: '',
          name: '',
          description: '',
          goodsPrice: '',
          count: 1,
        },
      ],
    },
    rules: {
      number: [
        { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
        {
          required: true,
          max: 20,
          message: MESSAGES.MAX_LENGTH(20),
          trigger: 'change',
        },
      ],
      serviceId: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
      workDate: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
      // workTime: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
      clientName: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
      clientPhone: [
        { required: true, message: MESSAGES.REQUIRED, trigger: 'change' },
        {
          min: 18, max: 18, message: MESSAGES.INCORRECT_PHONE, trigger: 'blur',
        },
      ],
      clientAdditionalPhone: [
        {
          min: 18,
          max: 18,
          message: MESSAGES.INCORRECT_PHONE,
          trigger: 'blur',
        },
      ],
      address: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
      // comment: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
      shop: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
      contractorId: [{ required: true, message: MESSAGES.REQUIRED, trigger: 'change' }],
    },
    required: {
      required: true,
      message: MESSAGES.REQUIRED,
      trigger: 'change',
    },

    pickerOptions: {
      firstDayOfWeek: 1,
      // disabledDate(time) {
      //   return time.getTime() < (new Date().getTime() - 1000 * 60 * 60 * 24);
      // },
    },
    MASKS,
  }),
  beforeCreate() {
    this.MESSAGES = MESSAGES;
  },
  created() {
    this.fetchServices();
    this.fetchContractors();
  },
  computed: {
    ...mapGetters({
      createProgress: 'orders/createProgress',
      services: 'servicesDrop/notArchivedItems',
      contractors: 'contractorsDrop/items',
    }),
  },
  methods: {
    ...mapActions({
      fetchServices: 'servicesDrop/fetchItems',
      createOrder: 'orders/createItem',
      fetchContractors: 'contractorsDrop/fetchItems',
    }),
    replaceNumberFloatingPoint,
    addItemOrderList() {
      const newItem = {
        orderNumber: '',
        vendorCode: '',
        name: '',
        description: '',
        goodsPrice: '',
        count: 1,
      };
      this.form.orderRows.push(newItem);
    },
    removeItemOrderList(id) {
      this.form.orderRows.splice(id, 1);
    },
    beforeClose(done) {
      if (!this.createProgress) {
        done();
      }
    },
    submitForm() {
      const data = {
        number: this.form.number,
        serviceId: this.form.serviceId,
        workDate: this.form.workDate,
        workTime: this.form.workTime,
        clientName: this.form.clientName,
        clientPhone: this.form.clientPhone,
        clientAdditionalPhone: this.form.clientAdditionalPhone,
        address: this.form.address,
        comment: this.form.comment,
        contractorId: this.form.contractorId,
        shop: this.form.shop,
        orderRows: this.form.orderRows.map((r) => ({ ...r, goodsPrice: Number(r.goodsPrice) })),
      };
      this.$refs.orderForm.validate((valid) => {
        if (valid) {
          this.createOrder({ data })
            .then(() => {
              this.$emit('update:visible', false);
            })
            .catch();
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.input-number {
  width: 100px;
}
.icon {
  &-delete {
    font-size: 20px;
  }
}
</style>
